<div class="flex">
  <sbnb-subnav class="w-[280px] hidden md:block" [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-add-edit-owner'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="w-full">
      <div class="flex mb-8 justify-between">
        <h2 class="flex-1 mb-0">Configure your accounting integration</h2>
      </div>

      <sbnb-statements-accounting-connection-form [editing]="true"></sbnb-statements-accounting-connection-form>
    </div>
  </main>
</div>
<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
